import React from 'react';

import { SegmentsContainer, Background } from './styles'


const Segments = ({image, text}) => {
  return (
      <SegmentsContainer>
          <Background image={image} />
          <strong>{text}</strong>
      </SegmentsContainer>
  )
}

export default Segments;
